/** Producer Trade Organization Dashboard. */
import TradeOrgShell from "../../TradeOrgShell";
import ProducerFeaturePanel from "./ProducerFeaturePanel";

const ACCENT = "#F5B82E";   // amber — producers own IP + finance

export default function ProducerDashboard() {
  return (
    <TradeOrgShell variantName="Producer" accent={ACCENT}>
      {({ org, quorum }) => (
        <ProducerFeaturePanel org={org} quorum={quorum} accent={ACCENT} />
      )}
    </TradeOrgShell>
  );
}
